import styled from 'styled-components'
import {
	LIGHTGRAY,
	PRIMARY_COLOR,
	MEDIUMGRAY
} from '../../../styles/colors.style'
import { breakpoints } from '../../../constants'

const StyledFooter = styled.footer`
	padding: 7.5rem 15px 12.5rem;
	border-top: 2px dashed ${LIGHTGRAY};

	@media (min-width: 768px) {
		padding: 7.5rem 9rem;
	}

	.row {
		display: flex;
		flex: 1;
		flex-direction: column;
		justify-content: space-between;
		width: 100%;

		@media (min-width: 768px) {
			align-items: center;
			flex-direction: row;
		}

		&:not(:last-child) {
			margin-bottom: 3rem;
		}

		&:last-child {
			@media (min-width: 1024px) {
				align-items: flex-end;
			}
		}
	}

	.column {
		align-items: flex-start;
		display: flex;
		font-size: 1.8rem;
		flex-direction: column;

		@media (min-width: 1024px) {
			flex-direction: row;
		}

		&:first-child {
			margin-bottom: 3rem;

			@media (min-width: 1024px) {
				margin: 0;
			}
		}

		& > *:not(:last-child) {
			margin-bottom: 15px;

			@media (min-width: 1024px) {
				margin-top: 0;
				margin-bottom: 0;
				margin-right: 15px;
			}
		}

		&.logos {
			display: none;
			flex: 1;

			button {
				all: unset;
				box-sizing: border-box;
				background: none;
				border: none;
				padding: 0;
				margin: 0;
				font: inherit;
				color: inherit;
				cursor: pointer;
			}

			@media (min-width: 1024px) {
				align-items: center;
				display: block;
			}
		}

		&.navigation {
			display: none;
			flex: 0.7;

			@media (min-width: 1024px) {
				display: block;
			}

			a {
				color: ${PRIMARY_COLOR};
			}
		}

		&.politics {
			text-align: center;
			align-items: center;
			@media (min-width: 1024px) {
				flex-wrap: wrap;
				text-align: left;
			}

			.info {
				display: none;

				@media (min-width: 1024px) {
					display: block;
				}
			}

			.faleconosco {
				width: 100%;
				margin-bottom: 15px;
				display: block;
			}

			a,
			p {
				color: ${MEDIUMGRAY};
			}

			a:hover {
				color: ${PRIMARY_COLOR};
			}

			.copyright {
				font-size: 1.8rem;
			}
		}

		&:not(.social) a,
		button {
			font-size: 1.8rem;
			text-decoration: none;

			&:hover {
				text-decoration: underline;
			}

			&:not(:last-child) {
				margin-right: 15px;
			}
		}

		&.social {
			font-size: 14px;
			align-items: center;
		}
	}

	.footer-btns-actions {
		display: flex;
		flex-direction: row;
		align-items: flex-end;

		.reclame-aqui-link {
			margin-bottom: -10px;
		}

		button {
			all: unset;
			box-sizing: border-box;
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			background: transparent;
			border: 0;
			padding: 0;
			margin: 0;
			color: inherit;
			cursor: pointer;
			line-height: normal;
			text-align: inherit;
		}

		div {
			a {
				display: block;
				width: auto;
				margin-right: 20px;

				img {
					width: 140px;
				}
			}
		}

		button,
		a {
			margin-right: 20px;
		}

		@media screen and (max-width: ${breakpoints.MEDIUM_SCREEN}px) {
			flex-direction: column;
			align-items: center;
		}
	}

	.logotipo {
		max-width: 199px;
	}

	.logotipo-planalto {
		margin-bottom: 0px;
	}

	.logotipo-unesul {
		margin-bottom: 0px;
	}

	.logotipo-ttl {
		margin-bottom: 0px;
	}

	.logotipo-planalto-menor {
		margin-bottom: 10px;
	}

	.developed-by {
		display: block;
		font-size: 1.8rem;
		line-height: 18px;
	}
`
export default StyledFooter
